import React, { useState } from 'react';

function SurveyStepTwentyThree({ formData, onNext }) {
    const [teamConnectionRating, setTeamConnectionRating] = useState(formData.teamConnectionRating || '');
    const [teamConnectionComments, setTeamConnectionComments] = useState(formData.teamConnectionComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!teamConnectionRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ teamConnectionRating, teamConnectionComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 5: Employee Experience</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How well connected do you feel to your team on both a professional and personal level? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`team-connection-rating-${option}`}
                            name="teamConnectionRating"
                            value={option}
                            checked={teamConnectionRating === option}
                            onChange={() => setTeamConnectionRating(option)}
                        />
                        <label htmlFor={`team-connection-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={teamConnectionComments}
                    onChange={(e) => setTeamConnectionComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!teamConnectionRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentyThree;
